import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserType } from 'identity-management';
import { AppRoutes } from 'shared-utils';
import { UserService } from 'shared-data-access';

export const isUserTypeBusinessGuardFn: CanActivateFn = (): Promise<boolean> | boolean => {
  const userService = inject(UserService);
  const userType: UserType = userService.getType();

  return [UserType.Internal, UserType.External].includes(userType) || inject(Router).navigate([AppRoutes.InvalidLink]);
};

export const isUserTypeCustomerFn: CanActivateFn = (): Promise<boolean> | boolean => {
  const userService = inject(UserService);
  const userType: UserType = userService.getType();

  return userType === UserType.Customer || inject(Router).navigate([AppRoutes.InvalidLink]);
};
